// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spinner_wrapper__1L8nk","spinner":"Spinner_spinner__1Nh-g","rotateAnimation":"Spinner_rotateAnimation__2d9ZT"};